export const EOGRE_PROFILE_SECTION_EVENT =
	'canvas-agent:eogre-profile:section';
export const EOGRE_PROFILE_CREATE_MODAL_EVENT =
	'canvas-agent:eogre-profile:create-modal';
export const EOGRE_PROFILE_FILTER_EVENT =
	'canvas-agent:eogre-profile:filter';
export const EOGRE_PROFILE_FOCUS_EVENT =
	'canvas-agent:eogre-profile:focus';
export const EOGRE_PROFILE_EDIT_MODAL_EVENT =
	'canvas-agent:eogre-profile:edit-modal';
export const EOGRE_PROFILE_DELETE_MODAL_EVENT =
	'canvas-agent:eogre-profile:delete-modal';
